/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/bookmark/bookmark',['require','underscore','marionette','modules/bookmark/api-local','modules/bookmark/api-lms'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var Marionette = require('marionette');

  var LocalStorage = require('modules/bookmark/api-local');
  var LMSStorage = require('modules/bookmark/api-lms');

  /*****************************************************************************************************************///}

  var Bookmark = Marionette.Module.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    API         : null,
    LocalAPI    : null,
    data        : { },
    scoreMethod : 'best', // any or best

  /////////////
  // METHODS /{
  /////////////

    onStart: function(options)
    {
      //console.log('Bookmark::start');
      this.LocalAPI = new LocalStorage();
      //this.patchAPI = new LocalStorage();

      switch (options.settings.bookmarking)
      {
        case 'auto':
          this.API = (window.API_FRAME) ? new LMSStorage() : new LocalStorage();
          break;
        case 'lms':
          this.API = new LMSStorage();
          break;
        case 'local':
          this.API = new LocalStorage();
          break;
        default:
          this.API = new LocalStorage();
          break;
      }
    },

    fetch: function()
    {
      this.data = {
        username: 'User, Test',
        userid: 0
      };
      this.localData = { };
      this.patchData = { };

      if (!this.API)
      {
        this.app.radio.trigger('bookmark.received', this.patchData, this.data, this.localData);
        return;
      }

      ////console.log('Bookmark::fetch');
      var courseID = this.app.module('Paging').courseID;
      var studentID = this.API.getStudentID();
      var attemptID = this.API.getAttemptID();
      this.LocalAPI.namespace = courseID + '.' + studentID + '.' + attemptID;
      //this.patchAPI.namespace = courseID + '.nolocalid'; // LM: hack for no bookmarking fix
      this.API.namespace = courseID + '.' + studentID + '.' + attemptID;

      this.data.location = this.API.getLocation();
      this.localData.location = this.LocalAPI.getLocation();
      //this.patchData.location = this.patchAPI.getLocation();

      this.data.datachunk = this.API.getDatachunk();
      this.localData.datachunk = this.LocalAPI.getDatachunk();
      //this.patchData.datachunk = this.patchAPI.getDatachunk();

      this.data.status = this.API.getStatus();
      this.localData.status = this.LocalAPI.getStatus();
      //this.patchData.status = this.patchAPI.getStatus();

      this.data.score = this.API.getScore();
      this.localData.score = this.LocalAPI.getScore();
      //this.patchData.score = this.patchAPI.getScore();

      this.data.username = this.API.getStudentName();
      this.localData.username = this.data.username;

      this.data.userid = this.API.getStudentID();
      this.localData.userid = this.data.userid;

      this.app.radio.trigger('bookmark.received', this.patchData, this.data, this.localData);

      return this.data;
    },

    save: function(data)
    {
      if (!this.API)
        return;
      //console.log('Bookmark::save', data);

      data = data || this.data;
      var localData = data || this.localData;

      //console.error(data);

      if (_.has(data, 'location'))
      {
        //console.log('location', data.location);
        // this.data.location = data.location;
        this.API.setLocation(data.location);
        this.LocalAPI.setLocation(localData.location);
      }

      if (_.has(data, 'datachunk'))
      {
        //console.log('datachunk', data.datachunk);
        this.API.setDatachunk(data.datachunk);
        this.LocalAPI.setDatachunk(localData.datachunk);
      }

      if (_.has(data, 'status'))
      {
        //console.log('status', data.status);
        this.API.setStatus(data.status);
        this.LocalAPI.setStatus(localData.status);
      }

      if (_.has(data, 'score'))
      {
        //console.log('score', data.score);
        this.API.setScore(data.score);
        this.LocalAPI.setScore(localData.score);
      }
    },

    setComplete: function(options)
    {
      if (!this.API)
        return;
      this.API.setComplete(options);
    }

  /*****************************************************************************************************************///}

  });

  return Bookmark;

});

